// extracted by mini-css-extract-plugin
export var button = "style-module--button--AjpyC";
export var contact = "style-module--contact--H11Ey";
export var contactInner = "style-module--contactInner--a-C+0";
export var content = "style-module--content--5+OY2";
export var heading = "style-module--heading--w-47Q";
export var headings = "style-module--headings--fbGKk";
export var text = "style-module--text--6gtNo";
export var title = "style-module--title--jDqiC";